import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useLolMasteryFullQuery } from '@/services/qriotsApi';
import type { Platform } from '@/types/qriots';
import { classifyQriotsError } from '@/services/qriotsErrors';
import { Loader } from '@/components/common/Loader';
import { MasteryDeepDive } from '@/components/riot/MasteryDeepDive';
import { QriotsErrorState } from '@/components/riot/QriotsErrorState';

export function RiotLolMastery() {
  const { t } = useTranslation('riot');
  const { puuid = '' } = useParams<{ puuid: string }>();
  const [search] = useSearchParams();
  const region = (search.get('region') ?? 'EUW1') as Platform;

  const result = useLolMasteryFullQuery(
    { puuid, region, count: 20 },
    { skip: !puuid },
  );

  if (result.isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (result.error) {
    const { kind, retryAfterSec } = classifyQriotsError(result.error);
    return (
      <QriotsErrorState
        kind={kind}
        retryAfterSec={retryAfterSec}
        onRetry={result.refetch}
      />
    );
  }

  if (!result.data) return null;

  return (
    <div className="flex flex-col gap-3">
      <div className="mx-4 pt-4">
        <h2 className="text-base font-bold text-fg">{t('mastery.title')}</h2>
      </div>
      <MasteryDeepDive data={result.data} />
    </div>
  );
}
